"use client"

import { useState, useEffect } from "react"
import Link from "next/link"
import Image from "next/image"
import ThemeToggle from "@/components/theme/theme-toggle"

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <div className={`header-blue kfjdsl--53 header-blue--bluebg m-t-0 ${isScrolled ? "active" : ""}`}>
      <div className="container-offer container-offer-1312">
        <div className="header-offer fg--rd-e">
          <Link href="/" className="link-logo-d link-param link-logo-d-new">
            <Image width="124" height="32" alt="ListKit Logo" src="/webflow-assets/images/logo-listkit.svg" className="lg-wa" />
            <Image height="32" width="124" src="/webflow-assets/images/log-dark.png" alt="ListKit Logo" className="lg-dark" />
          </Link>

          <div className="menu-header">
            <Link href="/pricing" className="menu-header__item link-param">
              Pricing
            </Link>

            <div className="cv-block-d">
              <div className="menu-header__item">
                <div>Comparison</div>
                <div className="cs-ccdere">
                  <svg
                    className="cv-io-rrr"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 11L11.8 15.8L16.6 11"
                      stroke="currentColor"
                      strokeOpacity="0.8"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="cvood-ede">
                <div className="cv-menus cv-menus--243">
                  <Link href="/listkit-alternatives" className="cv-ldoe link-param">
                    See All
                  </Link>
                  <Link href="/comparison-listkit-vs-apollo" className="cv-ldoe link-param">
                    LIstKit vs. Apollo.io
                  </Link>
                  <Link href="/comparison-listkit-vs-zoominfo" className="cv-ldoe link-param">
                    ListKit vs. Zoominfo
                  </Link>
                  <Link href="/comparison-listkit-vs-lusha" className="cv-ldoe link-param">
                    ListKit vs. Lusha
                  </Link>
                  <Link href="/comparison-listkit-vs-clearbit" className="cv-ldoe link-param">
                    ListKit vs. Clearbit
                  </Link>
                  <Link href="/comparison-listkit-vs-cognism" className="cv-ldoe link-param">
                    ListKit vs. Cognism
                  </Link>
                  <Link href="/comparison-listkit-vs-rocketreach" className="cv-ldoe link-param">
                    ListKit vs. RocketReach
                  </Link>
                  <Link href="/comparison-listkit-vs-snov-io" className="cv-ldoe link-param">
                    ListKit vs. Snov.io
                  </Link>
                  <Link href="/comparison-listkit-vs-seamless" className="cv-ldoe link-param">
                    ListKit vs. Seamless
                  </Link>
                  <Link href="/triple-verified-leads" className="cv-ldoe link-param">
                    Triple Verified Leads
                  </Link>
                </div>
              </div>
            </div>

            <div className="cv-block-d">
              <div className="menu-header__item">
                <div>About Us</div>
                <div className="cs-ccdere">
                  <svg
                    className="cv-io-rrr"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 11L11.8 15.8L16.6 11"
                      stroke="currentColor"
                      strokeOpacity="0.8"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="cvood-ede">
                <div className="cv-menus">
                  <Link href="/about" className="cv-ldoe link-param">
                    Our team
                  </Link>
                  <Link href="/job" className="cv-ldoe link-param">
                    Careers
                  </Link>
                </div>
              </div>
            </div>

            <Link href="/affiliates" className="menu-header__item link-param">
              Affiliates
            </Link>
            {/* <Link href="/case-studies" className="menu-header__item link-param">
              Case Studies
            </Link> */}
            <div className="cv-block-d">
              <div className="menu-header__item">
                <div>Expert Insights</div>
                <div className="cs-ccdere w-embed"><svg className="cv-io-rrr" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 11L11.8 15.8L16.6 11" stroke="currentColor" strokeOpacity="0.8" strokeWidth="1.5" strokeLinecap="round"></path>
                  </svg></div>
              </div>
              <div className="cvood-ede">
                <div className="cv-menus">
                  <Link href="/case-studies" aria-current="page" className="cv-ldoe link-param w--current">Case Studies</Link>
                  <Link href="/blog" className="cv-ldoe link-param">Blog</Link>
                </div>
              </div>
            </div>
          </div>

          <div className="dc-vk-w">
            <div className="links-menu vb-none">
              <Link href="/demo" className="menu-header__item link-param">
                Demo
              </Link>
              <Link
                href="https://app.listkit.io/login"
                target="_blank"
                className="menu-header__item menu-header__item--login link-param"
              >
                Log In
              </Link>
              <Link href="/pricing" className="menu-header__btn link-param">
                <div>Get Started Now</div>
              </Link>
            </div>

            <ThemeToggle />
            
            <Image
              loading="eager"
              src="/images/menu_mobile-wt-open.svg"
              alt="Menu"
              width={24}
              height={24}
              className="mobile-menu m-ui"
              onClick={() => setIsMenuOpen(true)}
            />
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`block-menu-mobile-f her-fdvc ${isMenuOpen ? "active" : ""}`}>
          <div className="header-offer">
            <Link href="/" className="link-param">
              <Image
                src="/webflow-assets/images/logo-offer.png"
                loading="lazy"
                width="100"
                height="32"
                alt="ListKit"
                className="vb-der-d"
              />
            </Link>
            <Image
              src="/webflow-assets/images/menu_mobile-wt-close.svg"
              loading="eager"
              alt="Close"
              width={24}
              height={24}
              className="mobile-menu-close vcfg"
              onClick={() => setIsMenuOpen(false)}
            />
          </div>

          <div className="links-cddf">
            <Link href="/pricing" className="nik-link vb-of-r link-signup">
              Pricing
            </Link>
            <Link href="/listkit-alternatives" className="nik-link vb-of-r link-param">
              Comparison
            </Link>
            <Link href="/about" className="nik-link vb-of-r link-param">
              About Us
            </Link>
            <Link href="/affiliates" className="nik-link vb-of-r link-param">
              Affiliates
            </Link>
            <Link href="/case-studies" className="nik-link vb-of-r link-param">
              Case Studies
            </Link>
            <Link href="/demo" className="nik-link vb-of-r link-param">
              Demo
            </Link>
            <Link href="https://app.listkit.io/login" target="_blank" className="nik-link vb-of-r link-login">
              Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
